/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';

const ModeOfTransportDropdown = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {

    const [options, setOptions] = useState([])

    useEffect(()=>{
        ReadAxios({
            completeURL : `${process.env.REACT_APP_MASTER_API}/trasnportMode`
        }).then((res)=>{
            if(res?.data?.resultSet?.length){
                let formatted_options = []
                res.data.resultSet.map((data)=>{
                    formatted_options.push({
                        key : data?.trasnportModeMasterId,
                        text : data?.transportMode,
                        value : data?.trasnportModeMasterId
                    })
                })
                setOptions(formatted_options)
            }
        }).catch((err)=>{
            console.log(`Error in mode of transport dropdown>>>`,err);
        })
    },[])

    return (
        <Dropdown
            selection
            onChange={(value, data) => setFieldValue(name, data.value)}
            options={options}
            {...props}
            
        />
    )
}

export default ModeOfTransportDropdown